export enum SendMail {
  ALL = 'all',
  OTHERS = 'others',
  NONE = 'none'
}
